import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

import { useStyles } from "./UserAttendance.css";
import UserHeader from "../../../Components/NavBar/User/UserHeader/UserHeader";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../Config/Config";
import { getUserRefreshToken } from "../../../Redux/Actions/actions";
import PageTitle from "../../../Components/PageTitle/PageTitle";

const localizer = momentLocalizer(moment);

class UserAttendance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attendances: [],
      attendanceData: [],
    };
  }

  componentDidMount() {
    this.getUserTimetable();
  }

  getUserTimetable = async () => {
    try {
      let attendanceResponse = [];
      if (this.props.role === "Teacher") {
        const teacherResponse = await Axios.get(
          `${url}/api/staffs/teacher/${this.props.userId}`,
          {
            headers: {
              Authorization: `Bearer ${this.props.userToken}`,
            },
          }
        );
        const response = await Axios.get(`${url}/api/staff-attendance`, {
          params: {
            staffId: teacherResponse.data.teacher._id,
          },
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        attendanceResponse = response.data.attendances;
      } else {
        const responseStudent = await Axios.get(
          `${url}/api/students/${this.props.userId}`,
          {
            headers: { Authorization: `Bearer ${this.props.userToken}` },
          }
        );
        const response = await Axios.get(`${url}/api/student-attendance`, {
          params: {
            studentId: responseStudent.data.student._id,
            admissionId: responseStudent.data.student.admissionId,
          },
          headers: {
            Authorization: `Bearer ${this.props.userToken}`,
          },
        });
        attendanceResponse = response.data.attendances;
      }
      if (attendanceResponse.length !== 0) {
        let attendanceData = [];
        for (let i = 0; i <= attendanceResponse.length - 1; i++) {
          let count = 1;
          let title =
            attendanceResponse[i].status === "P"
              ? "Present"
              : attendanceResponse[i].status === "A"
              ? "Absent"
              : attendanceResponse[i].status === "L" && "Leave";
          let color =
            attendanceResponse[i].status === "P"
              ? "green"
              : attendanceResponse[i].status === "A"
              ? "red"
              : attendanceResponse[i].status === "L" && "orange";
          let date = attendanceResponse[i].date;
          attendanceData.push({
            id: count,
            title: title,
            start: date,
            end: date,
            color: color,
          });
          count++;
        }
        this.setState({
          attendanceData,
          attendances: attendanceResponse,
          isEmpty: false,
        });
      } else {
        this.setState({
          attendanceData: [],
          attendances: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.userRefreshToken };
        this.props.getUserRefreshToken(refreshToken, this.props.role);
        this.getUserTimetable();
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <UserHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />
          <div className={classes.sectionDesktop}>
            <PageTitle title="Attendances" refreshUrl={this.props.match.url} />
          </div>
          <Calendar
            localizer={localizer}
            events={this.state.attendanceData}
            startAccessor="start"
            endAccessor="end"
            views={["month"]}
            style={{ minHeight: "100vh" }}
            eventPropGetter={(event) => {
              const eventData = this.state.attendanceData.find(
                (data) => data.id === event.id
              );
              const backgroundColor = eventData && eventData.color;
              return { style: { backgroundColor } };
            }}
          />
          <div style={{ paddingBottom: 20 }}>
            <div>Index</div>
            <div>
              <Chip
                label="Present"
                style={{ backgroundColor: "green", marginRight: 10 }}
              />
              <Chip
                label="Absent"
                style={{ backgroundColor: "red", marginRight: 10 }}
              />
              <Chip
                label="Leave"
                style={{ backgroundColor: "orange", marginRight: 10 }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserReducer.userId,
    userToken: state.UserReducer.userToken,
    userRefreshToken: state.UserReducer.userRefreshToken,
    role: state.UserReducer.role,
    isUser: state.UserReducer.isUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUserRefreshToken: (refreshToken, role) => {
      dispatch(getUserRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(UserAttendance));
